import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { LIB_CONFIG, LibConfig } from '../../../lib.config';
import { LoaderService } from '../../../services/loader.service';
import { OrtFacettenService } from '../../../services/facetten/instance/ort-facetten.service';
import { BasisFacetteComponent } from '../basis-facette/basis-facette.component';
import { OrtSucheOrtsunabhaengigComponent } from './ort-suche-ortsunabhaengig.component/ort-suche-ortsunabhaengig.component';
import { OrtSucheSuchzeileComponent } from './ort-suche-suchzeile/ort-suche-suchzeile.component';

@Component({
  selector: 'now-wbsuche-lib-ort-facette',
  imports: [
    BasisFacetteComponent,
    CommonModule,
    OrtSucheSuchzeileComponent,
    OrtSucheOrtsunabhaengigComponent
  ],
  templateUrl: './ort-facette.component.html'
})
export class OrtFacetteComponent {
  facettenService = inject(OrtFacettenService);
  loaderService = inject(LoaderService);
  private readonly libConfig = inject<LibConfig>(LIB_CONFIG);

  @Input()
  postleitzahl?: string;

  public showOrtsunabhaengig = this.libConfig?.showOrtsunabhaengig ?? true;

  public expanded = toSignal(this.facettenService.expanded$);
}
